import { render } from "./BlogPostModalComponent.vue?vue&type=template&id=19e096a9&scoped=true"
import script from "./BlogPostModalComponent.vue?vue&type=script&lang=js"
export * from "./BlogPostModalComponent.vue?vue&type=script&lang=js"

import "./BlogPostModalComponent.vue?vue&type=style&index=0&id=19e096a9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19e096a9"]])

export default __exports__